import PropTypes from 'prop-types';
import React from 'react';
import {Segment} from 'semantic-ui-react';

import Table from '@appComponents/Table';
import {Columns} from '@modules/events/components/EventsConfigurationTargets/components/Table/EventsConfigurationTargetsColumns';
import {RowRenderer} from '@modules/events/components/EventsConfigurationTargets/components/Table/EventsConfigurationTargetsRowRenderer';
import {getRowClassname} from '@modules/events/utils/eventsConfigurationTargetsTableHelper';
import {sortTargets} from '@modules/events/components/EventsConfigurationTargets/utils/helpers';

const EventsConfigurationTargetsTable = (props) => {
    const {targets, loading} = props;

    return (
        <Segment basic className='event_configuration_target__table --noPadding'>
            <Table
                name='eventConfigurationTargetList'
                columns={Columns}
                data={targets}
                noDataText='No encoding targets defined.'
                noMessageBox
                loading={loading}
                defaultSort={sortTargets}
                rowRenderer={RowRenderer}
                rowRendererProps={{...props}}
                pagination={false}
                className='mini'
                rowClassname={getRowClassname}
            />
        </Segment>
    );
};

EventsConfigurationTargetsTable.defaultProps = {
    targets: [],
};

EventsConfigurationTargetsTable.propTypes = {
    loading: PropTypes.bool,
    targets: PropTypes.array,
};

export default EventsConfigurationTargetsTable;
